const inputRelationalNtoNOrderingSkin = {
  "drag-n-drop-board": {
    flexDirection: "row",
    display: "flex",
    justifyContent: "space-between",
  },
  "draggable-container": {
    display: "flex",
    flexDirection: "column",
    width: "48%",
    height: 180,
    overflow: "auto",
    padding: 10,
    border: "2px dashed var(--gc-border-separator-color)",
  },
  "draggable-item": {
    padding: "5px 10px",
    margin: "0 0 5px 0",
    border: "1px solid var(--gc-border-separator-color)",
    backgroundColor: "var(--gc-default-background)",
    borderRadius: 4,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  "draggable-item-selected": {
    backgroundColor: "#ddd",
    color: "#181a1b",
    border: "1px solid #bbb",
    "& .fas": {
      color: "#181a1b",
    },
    "& .btn-outline-dark:hover .fas": {
      color: "#ffffff",
    },
  },
  "selected-items-info-container": {
    width: "48%",
    padding: "0 5px 10px 0",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  "unselected-items-info-container": {
    width: "48%",
    padding: "0 5px 10px 0",
    display: "flex",
    justifyContent: "space-between",
  },
  "select-all-none-button": {
    composes: "btn btn-default btn-outline-dark",
  },
  "add-remove-button": {
    composes: "btn btn-sm btn-default btn-outline-dark",
  },
};

export default inputRelationalNtoNOrderingSkin;
